// External Dependencies
import React from 'react';

// Internal Dependencies
import DrumCorpsImage from '../../components/images/drum-corps-image';
import IronYardAustinImage from '../../components/images/iron-yard-austin-image';
import MathewFamilyApril2019Image from '../../components/images/mathew-family-april-2019-image';
import MichaelAndMelissaImage from '../../components/images/michael-and-melissa-image';
import MichaelAndStephenTmea2019Image from '../../components/images/michael-and-stephen-tmea-2019-image';
import MikeThumbsUpImage from '../../components/images/mike-thumbs-up-image';
import ReactMeetupMarch2016MikeImage from '../../components/images/react-meetup-march-2016-mike-image';
import TrinityPasicImage from '../../components/images/trinity-pasic-image';
import PrestoTmeaBoothImage from '../../components/images/2025-presto-tmea-booth';

// Local Variables
export const bioPhrases = [
  {
    text: 'How to make a front end developer named Mike',
    image: null,
  },
  {
    text: 'Fall in love with learning',
    image: null,
  },
  {
    text: 'Get a TRS-80 from Uncle Ricky and learn to program in BASIC',
    image: null,
  },
  {
    text: 'Start hitting things with drumsticks',
    image: null,
  },
  {
    text: 'Play lots of video games',
    image: null,
  },
  {
    text: 'Take two years of Computer Science in high school using C++ and Turbo Pascal',
    image: null,
  },
  {
    text: 'Sit next to future wife in Computer Science',
    image: null,
  },
  {
    text: 'Decide to major in Music Education in college',
    image: null,
  },
  {
    text: 'Tour and perform with a drum and bugle corps',
    image: <DrumCorpsImage />,
    dialogText: 'I performed with the Troopers in 1996 and Carolina Crown in 2000 (pictured, far right, in Montreal), both playing quads in the drum line. This experience is unlike anything else. We traveled on charter buses for a summer and stayed in high schools in each city. Imagine the army meets marching band.',
  },
  {
    text: 'Spend equal time writing music as performing it',
    image: null,
  },
  {
    text: 'Get married to your high school sweetheart',
    image: <MichaelAndMelissaImage />,
    dialogText: 'Melissa and I were married in December 2000 after dating since high school. Still going strong with a great family!',
  },
  {
    text: 'Graduate college and teach music for over a decade',
    image: null,
  },
  {
    text: 'Convince students to work hard enough to win an international competition',
    image: <TrinityPasicImage />,
    dialogText: 'As winners of the International Percussion Ensemble Contest, my students at Trinity High School were invited to perform at the 2006 Percussive Arts Society International Convention in Austin, Texas. We commissioned a new work for percussion ensemble from composer Dwayne Rice that we premiered at this concert where we featured the rock star percussionist Dr. Andrew Eldridge. The students played great, and we had a blast!',
  },
  {
    text: 'Make websites for your band programs',
    image: null,
  },
  {
    text: 'Have three kids along the way',
    image: <MathewFamilyApril2019Image />,
    dialogText: 'Isaac (b.2002), Alexis (b.2005), and Olivia (b.2012) bring their parents great joy. We have lots of laughter throughout our house!',
  },
  {
    text: 'Realize that you spend as much time formatting an email as teaching',
    image: null,
  },
  {
    text: 'Become the guardian for your little brother',
    image: <MichaelAndStephenTmea2019Image />,
    dialogText: 'Michael and Stephen meet up in the Exhibit Hall at the 2019 Texas Music Educators Association convention in San Antonio, TX. Stephen has worked in marketing for music companies.',
  },
  {
    text: 'Start learning more code',
    image: null,
  },
  {
    text: 'Switch gears from working as a band director to working as a web developer',
    image: null,
  },
  {
    text: 'Enroll at a code school three hours from home',
    image: <IronYardAustinImage />,
    dialogText: 'My time in code school at The Iron Yard- Austin was an immersive dive into front end coding and development. My instructor Aaron Larner always gave us the nudge we needed to solve problems ourselves. We also used Agile methodology for three projects and built applications on teams with back end and design students.',
  },
  {
    text: 'Work at an awesome company',
    image: <MikeThumbsUpImage />,
    dialogText: 'At Text-Em-All I have learned and leveled up in technical skills. The team created the popular open source library Material UI (MUI). I have used that library every day for years. Also, as a Small Giants company, we enjoy a good deal of transparency into how all aspects of the company are run. I have mentored several interns and even worked as a Product Owner and Project Manager. Good times!',
  },
  {
    text: 'Start my own company Presto Assistant to help fine arts teachers',
    image: <PrestoTmeaBoothImage />,
    dialogText: 'Presto Assistant builds tools for fine arts teachers all over the United States. For me, the work is a perfect connection between my love of teaching and my love of coding. We have built a great team to help us build the best tools for teachers!',
  },
  {
    text: 'Help others learn and stay connected',
    image: <ReactMeetupMarch2016MikeImage />,
    dialogText: 'Since Feb 2016 I have served as the main organizer for the ReactJS Dallas User Group. We have built a great community around ReactJS in Dallas where we routinely visit local company offices like Intuit, Match, The Container Store, and many more. Our members love to connect with each other over code and pizza. Our events help a lot of people find jobs, too!',
  },
  {
    text: 'Keep learning and making awesome things',
    image: null,
  },
];
